import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import HotelHeaderNav from "./HotelHeaderNav";
import HotelSideNav from "./HotelSideNav";

export default function AdminDashboardlayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeMenu, setActiveMenu] = useState("Dashboard");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setSidebarOpen(false);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="app-wrapper">
      <HotelSideNav
        open={sidebarOpen}
        toggle={() => setSidebarOpen(!sidebarOpen)}
        activeMenu={activeMenu}
        setActiveMenu={setActiveMenu}
      />

      <div className={`main-section ${sidebarOpen ? "shift" : ""}`}>
        <HotelHeaderNav onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
        <div className="content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
